import { c as _c } from "react/compiler-runtime";
import { useImageProvider } from '@7f-ui';
import Image from 'next/image';
import { DestinationsTags } from './destinations-tags';
type Media = {
  url: string;
  alt: string;
};
type DestinationsHeroMediaProps = {
  image: Media | null | undefined;
  tags?: string[];
};
export function DestinationsHeroMedia(t0) {
  const $ = _c(13);
  const {
    image: initialImage,
    tags
  } = t0;
  const {
    logo
  } = useImageProvider();
  let t1;
  if ($[0] !== initialImage || $[1] !== logo) {
    t1 = initialImage ?? {
      url: logo.fallbackSrc,
      alt: ""
    };
    $[0] = initialImage;
    $[1] = logo;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const image = t1;
  let t2;
  if ($[3] !== image.alt || $[4] !== image.url) {
    t2 = <Image src={image.url} alt={image.alt} className="rounded-2xl object-cover" fill={true} />;
    $[3] = image.alt;
    $[4] = image.url;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== tags) {
    t3 = tags && tags.length > 0 && <div className="hidden sm:block"><DestinationsTags tags={tags} /></div>;
    $[6] = tags;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <div className="absolute inset-0 flex items-end p-6">{t3}</div>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <div className="relative aspect-4/3 sm:aspect-21/9">{t2}{t4}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}